import { tUserRole } from "../../common/types"

export type tProps = {
    isSidebarCollapsed: boolean
    user_role: tUserRole
    email: string
    name?: string
    style?: React.CSSProperties
}

const UserInfo = (props: tProps): JSX.Element | null => {
    const { isSidebarCollapsed, user_role, email, name, style } = props
    return !isSidebarCollapsed ? (
        <div className="sidebar-user-info-section" style={style}>
            <div className="sidebar-user-role-text">{user_role}</div>
            {name && <div className="sidebar-user-name">{name}</div>}
            <div className="sidebar-user-email sidebar-foreground-text">{email}</div>
        </div>
    ) : null
}

export default UserInfo
